import { render, staticRenderFns } from "./material_resources.vue?vue&type=template&id=78ac57ef&scoped=true"
import script from "./material_resources.vue?vue&type=script&lang=js"
export * from "./material_resources.vue?vue&type=script&lang=js"
import style0 from "./material_resources.vue?vue&type=style&index=0&id=78ac57ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac57ef",
  null
  
)

export default component.exports